import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import { AgentInputType } from '../../../../types/AgentInputType.types';
import { AgentStatus } from '../../../../types/Agent.types';
import lastDismissedDay from '../../../../services/lastDismissedDay';
import AgentFormDismiss from '../AgentFormDismiss';
import PanelCard from './PanelCard';

function DismissPanel() {
  const theme = useTheme();
  const { values } = useFormikContext<AgentInputType>();

  return (
    <Box>
      {values.dismissed_at && (
        <PanelCard title="Kündigungsdetails" isDanger>
          <Typography sx={{ color: theme.palette.error.main, fontWeight: 'bold', mb: 1 }}>
            KÜNDIGUNG: Der Berater {values.status_id === AgentStatus.dismissed ? 'WURDE AM' : 'WIRD ZUM'}{' '}
            {values.dismissed_at.split('T')[0]} gekündigt
          </Typography>
          <Typography sx={{ color: theme.palette.error.main, fontWeight: 'bold', mb: 1 }}>
            STATUS: Statusänderung auf &apos;Gekündigt&apos; erfolgt automatisch am{' '}
            {lastDismissedDay(values.dismissed_at?.split('T')[0])}
          </Typography>
          <Typography sx={{ color: theme.palette.error.main, fontWeight: 'bold' }}>
            KÜNDIGUNGSGRUND: {values.dismissal_reason}
          </Typography>
        </PanelCard>
      )}

      <PanelCard
        title="Berater kündigen"
        subtitle="Achtung: Diese Aktion kann nicht rückgängig gemacht werden"
        isDanger
      >
        <AgentFormDismiss />
      </PanelCard>
    </Box>
  );
}

export default DismissPanel;
